<template>
    <tr class="tw-border-b tw-border-solid tw-border-gray-100 last:tw-border-b-0 tw-group hover:tw-bg-gray-50/50 tw-transition-colors tw-duration-200">
        <!-- Image -->
        <td class="tw-px-4 tw-py-3">
            <div class="tw-flex-shrink-0 tw-h-10 tw-w-10">
                <img 
                    :src="sponsor.image" 
                    :alt="sponsor.name"
                    class="tw-h-10 tw-w-10 tw-rounded-lg tw-object-cover tw-border tw-border-gray-200"
                    @error="handleImageError"
                />
            </div>
        </td>

        <!-- Name -->
        <td class="tw-px-4 tw-py-3">
            <div class="tw-text-sm tw-font-medium tw-text-gray-900 tw-truncate tw-max-w-[200px]" :title="sponsor.name">
                {{ sponsor.name }}
            </div>
            <div v-if="sponsor.description" class="tw-text-sm tw-text-gray-600 tw-truncate tw-max-w-[250px]" :title="sponsor.description">
                {{ sponsor.description }}
            </div>
        </td>

        <!-- Link -->
        <td class="tw-px-4 tw-py-3">
            <a 
                v-if="sponsor.link"
                :href="sponsor.link" 
                target="_blank" 
                rel="noopener noreferrer"
                class="tw-text-sm tw-text-blue-600 hover:tw-text-blue-900 tw-flex tw-items-center tw-gap-1 tw-truncate tw-max-w-[250px]"
                :title="sponsor.link"
            >
                <i class="ri-external-link-line"></i>
                {{ sponsor.link }}
            </a>
            <span v-else class="tw-text-sm tw-text-gray-500">
                {{ $t('common.no-link') }}
            </span>
        </td>

        <!-- Status -->
        <td class="tw-px-4 tw-py-3">
            <span 
                :class="[
                    'tw-px-2.5 tw-py-1 tw-inline-flex tw-text-xs tw-leading-5 tw-font-medium tw-rounded-md',
                    sponsor.is_active 
                        ? 'tw-bg-green-50 tw-text-green-700' 
                        : 'tw-bg-red-50 tw-text-red-700'
                ]"
            >
                {{ sponsor.is_active ? $t('common.active') : $t('common.inactive') }}
            </span>
        </td>

        <!-- Created At -->
        <td class="tw-px-4 tw-py-3 tw-text-sm tw-text-gray-500">
            {{ formatDate(sponsor.created_at) }}
        </td>

        <!-- Actions -->
        <td class="tw-px-4 tw-py-3">
            <SponsorTableActions 
                :item="sponsor"
                @edit="$emit('edit', sponsor)"
                @delete="$emit('delete', sponsor)"
                @toggle-status="$emit('toggle-status', sponsor)"
            />
        </td>
    </tr>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';
import SponsorTableActions from './SponsorTableActions.vue';

defineProps({
    sponsor: {
        type: Object,
        required: true
    }
});

defineEmits(['edit', 'delete', 'toggle-status']);

const handleImageError = (e) => {
    // Set a default image if the sponsor image fails to load
    e.target.src = '/assets/images/empty-state/companies.svg';
};

const formatDate = (dateString) => {
    if (!dateString) return '-';
    
    try {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    } catch (error) {
        return dateString;
    }
};
</script>
